import { registry } from 'Store';
import {
  GET_DASHBOARD,
  GET_DASHBOARD_NO_LOADING_INDICATOR,
  START_PURCHASE_WITH_VEHICLE_ID,
  SWITCH_VEHICLE
} from 'Components/dashboard/ducks/action-types';
import * as operations from './operations';
import { UPDATE_VEHICLE_ID_AND_OR_STOCK_NUMBER_FROM_URL } from './actions';

export const vehicleState = {
  isLoading: false,
  isMarketplaceVehicle: false,
  srcImageUrl: '',
  closeUpSrcImageUrl: ''
};

export default function reducer(state = vehicleState, action) {
  const { type, payload } = action;

  switch (type) {
    case UPDATE_VEHICLE_ID_AND_OR_STOCK_NUMBER_FROM_URL:
      return {
        ...state,
        browser: {
          ...payload,
          switchingVehicle: false
        }
      };

    case `${GET_DASHBOARD}_LOADING`:
      return {
        ...state,
        isLoading: true
      };

    case `${SWITCH_VEHICLE}_LOADING`: {
      return {
        ...state,
        switchingVehicle: true
      };
    }

    case `${GET_DASHBOARD}_SUCCESS`:
    case `${GET_DASHBOARD_NO_LOADING_INDICATOR}_SUCCESS`:
    case `${GET_DASHBOARD}_ERROR`:
    case `${START_PURCHASE_WITH_VEHICLE_ID}_SUCCESS`:
    case `${SWITCH_VEHICLE}_SUCCESS`: {
      const vehicle = payload?.vehicle;

      return {
        ...state,
        ...payload?.vehicle,
        srcImageUrl: operations.getVehicleImageUrl(vehicle?.stockNumber),
        closeUpSrcImageUrl: operations.getCloseUpVehicleImageUrl(
          vehicle?.stockNumber
        ),
        lock: { ...payload?.vehicleLock },
        isLoading: false,
        isMarketplaceVehicle: vehicle?.inventoryType === 'DealerMarketplace'
      };
    }

    case `${START_PURCHASE_WITH_VEHICLE_ID}_ERROR`:
      return {
        ...state,
        isLoading: false
      };

    default:
      return state;
  }
}

registry.register('vehicle', reducer, vehicleState);
